<template>
    <div class="container">
        <h6 v-if="$store.getters.GET_SEARCHED_ADDRESSES.fetched && $store.getters.GET_SEARCHED_ADDRESSES.list.length === 0" class="font-weight-bold text-center mb-4 text-danger"  v-html="noResultsText"></h6>
        <div class="text-danger text-center mb-4">{{ errorMessage }}</div>
        <div class="booking-service">
            <address-pin />
            <upcoming-collection-summary v-if="isBinCollectionEnabled && !isEnabledQuickView" :addressId="activeAddressId" :isCompactDisplay="true"/>
            <bin-details-overview v-if="isEnabledQuickView && activeAddressId" />
            <favourite-address />
        </div>
    </div>
</template>

<script>
    import AddressPin from './AddressPin';
    import UpcomingCollectionSummary from './UpcomingCollectionSummary';
    import FavouriteAddress from './FavouriteAddress';
    // import BookingStateManager from '../../../../common/utils/BookingStateManager';
    import BinDetailsOverview from './BinDetailsOverview';

    export default {
        components: {
            AddressPin,
            FavouriteAddress,
            UpcomingCollectionSummary,
            BinDetailsOverview
        },
        mounted(){
            // this.$store.dispatch('getSiteWordingsSettings');
            // this.$store.dispatch('setActiveMultipleServiceBookingSetting')
        },
        computed: {
            siteWordings() {
                return this.$store.getters['GET_SITE_WORDINGS']; 
            },
            noResultsText(){
                if(this.siteWordings && this.siteWordings.no_search_result_text){
                    return this.siteWordings.no_search_result_text
                }
                else{
                    return "No results found."
                }
            },
            activeAddressId(){
              var address = this.$store.getters['GET_ACTIVE_ADDRESS']
              return address ? address.id : null
            },
            isBinCollectionEnabled(){
              var multipleServiceBookingSetting = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_BOOKING_SETTING
              return multipleServiceBookingSetting && multipleServiceBookingSetting.enable_bin_collection == 1
            },
            isEnabledQuickView() {
                const multipleServiceBookingSetting = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_BOOKING_SETTING
                return this.$store.getters.GET_PERSONAL_INFO.type === 'cso' && multipleServiceBookingSetting && multipleServiceBookingSetting.cso_quick_view == 1
            },
            errorMessage() {
                return (!this.$store.getters.GET_SEARCHED_ADDRESSES.error &&
                        this.$store.getters.GET_SEARCHED_ADDRESSES.error.indexOf('Cancel') &&
                        this.$store.getters.GET_SEARCHED_ADDRESSES.error)
                        || '';
            }
        },
    }
</script>

<style